import React, { memo } from 'react'
import { useParams } from 'react-router'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { Toast } from 'transfix-ui'
import { FORMATS } from 'constants/datetime'

export enum PAGE {
  fleet = 'fleet',
  loads = 'loads',
}
interface IShareLoadToastMessageProps {
  shipmentId: string
  message: string
  onClose: () => void
  page: PAGE
}

export const ShareLoadToastMessage = memo<IShareLoadToastMessageProps>(
  ({ message, onClose, page, shipmentId }) => {
    const { date: fleetUrlDate = moment().format(FORMATS.urlDateFormat) } = useParams<{
      date: string
    }>()
    const shareLoadsUrl =
      page === PAGE.fleet ? `${fleetUrlDate}/${shipmentId}/share` : `/loads/${shipmentId}/share`
    return (
      <Toast
        variation='default'
        open={!!shipmentId}
        onClose={onClose}
        message={
          <div>
            <span className='body-bold'>{message} </span>
            <Link className='toast-btn-link' to={shareLoadsUrl}>
              Share load with your driver
            </Link>
          </div>
        }
      />
    )
  }
)
